<div
  appClickOutside
  (clickOutside)="handleClickOutside()"
  class="panel"
  [ngClass]="{
    'recent-search': searchType() === recent(),
    'quick-search': searchType() === quick(),
    'small-version': isSmallVersion(),
    'flat-panel': showAllResults(),
    'open-panel': showSearchPanel(),
  }"
>
  @if (!showAllResults()) {
    <div class="search-title">
      <p class="headline-small bold flex flex-center">
        <mat-icon
          [fontIcon]="searchType() === recent() ? 'bookmark' : 'auto_awesome'"
          class="icon-s"
        ></mat-icon>
        {{
          searchType() === recent()
            ? ('OPEN_SEARCH.RECENT_SEARCH' | translate)
            : ('OPEN_SEARCH.QUICK_SEARCH' | translate)
        }}
      </p>

      @if (!isSmallVersion()) {
        @if (Projectslength() && searchType() === quick()) {
          <p class="body-large italic">
            {{ 'OPEN_SEARCH.PROMPTS_TAILORED' | translate }}
          </p>
        }
        <p class="body-large">
          {{
            searchType() === recent()
              ? ('OPEN_SEARCH.RECENT_SEARCH_INFO' | translate)
              : Projectslength()
                ? ('OPEN_SEARCH.PICK_AND_CUSTOMIZE' | translate)
                : ('OPEN_SEARCH.PICK_PROMPT' | translate)
          }}
        </p>
      }
      @if (isSmallVersion()) {
        <button class="btn-link btn-close" data-fs-element="Open-Search-Panel-Button-Close" (click)="setShowSearchPanel(false)">
          <mat-icon fontIcon="close" class="icon-m"></mat-icon>
        </button>
      }
    </div>
  }
  @if (searchType() === quick()) {
    <div class="flex flex-center select-quick">
      <app-select-category
        [(categoryOptions)]="categoryOptions"
        [(items)]="items"
        [(filteredItems)]="filteredItems"
      />

    </div>
  }

  <div
    class="bkg-container flex flex-column"
    [ngClass]="{
      recent: searchType() === recent(),
      quick: searchType() === quick(),
      empty: !items.length,
      'flat-panel': showAllResults(),
    }"
  >
    <ul
      class="search-list"
      [ngClass]="{
        'recent-search': searchType() === recent(),
        'quick-search-list': searchType() === quick(),
      }"
    >
      @if (searchType() === quick()) {
        @for (
          item of currentQuickItems() | sliceArrayItems: searchType() : showAllResults();
          track i;
          let i = $index
        ) {
          <li
            data-fs-element="Open-Search-Prompt-Item"
            class="item body-large"
            [ngClass]="{ active: item.selected, 'flat-li': showAllResults() }"
            (click)="onClickItem(i)"
          >
            <mat-icon fontIcon="search" class="icon-m"></mat-icon>
            <p [innerHTML]="item.text | changeLanguage"></p>
          </li>
        }
      }

      @if (searchType() === recent()) {
        @for (conversation of currentRecentItems(); track conversation.id; let i = $index) {
          @if (conversation.context || conversation.title) {
            <li
              data-fs-element="Open-Search-Prompt-Item"
              class="item body-large"
              [ngClass]="{ 'flat-li': showAllResults() }"
              (click)="onClickItem(conversation)"
            >
              <p class="text">
                {{
                  (conversation.context ? conversation.context : conversation.title)
                    | recentSearchCleanFormat
                }}
              </p>
              @if (conversation.lastUpdated) {
                <div class="date">
                  <mat-icon fontIcon="schedule" class="icon-s"></mat-icon>
                  <span class="body-medium">
                    {{ conversation.lastUpdated | date: 'dd/MM/yyyy' }}
                  </span>
                </div>
              }
            </li>
          }
        }
      }
    </ul>

    @if (
      !showAll() &&
      !(
        (!currentRecentItems().length && searchType() === recent()) ||
        (!currentQuickItems().length && searchType() === quick())
      )
    ) {
      <div class="search-footer">
        <button
          data-fs-element="Open-Search-Prompts-Button-Explore-All"
          class="btn-link btn-icon-left mb-1"
          (click)="onShowExploreAll()"
        >
          {{ 'OPEN_SEARCH.EXPLORE_ALL' | translate }}
          <mat-icon fontIcon="arrow_forward_ios" class="icon-s"></mat-icon>
        </button>
      </div>
    }

    @if (
      (!currentRecentItems().length && searchType() === recent()) ||
      (!currentQuickItems().length && searchType() === quick())
    ) {
      <div class="empty-state">
        <img src="/images/empty-search.png" />
        @if (searchType() === recent()) {
          <p class="body-large-semi-bold">
            {{ 'OPEN_SEARCH.NO_RECENT_SEARCHES' | translate }}
          </p>
          <p class="body-medium">
            {{ 'OPEN_SEARCH.NO_RECENT_SEARCHES_INFO' | translate }}
          </p>
        }
      </div>
    }
  </div>
</div>
@if (showAllResults() && searchType() === recent()) {
  <div class="paginator">
    <div class="custom-paginator">
      <span class="paginator-info">
        {{ currentPageStart() }} – {{ currentPageEnd() }} of {{ totalItems() }}
      </span>
      <button
        data-fs-element="Open-Search-Panel-Button-Previous-Page"
        mat-icon-button
        class="paginator-btn"
        [disabled]="currentPage() <= 1"
        (click)="onPreviousPage()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        data-fs-element="Open-Search-Panel-Button-Next-Page"
        mat-icon-button
        class="paginator-btn"
        [disabled]="currentPage() >= totalPages()"
        (click)="onNextPage()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
}
